/**
 * Main App component
 */

import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Layout } from '@/components/layout';
import { Dashboard, Tenants, Workspaces, Users, Settings, Support } from '@/pages';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { Login } from '@/components/Login';
import { AuthCallback } from '@/components/AuthCallback';
import { ConfigProvider } from '@/config';
import { AuthGlobalHandler } from '@/components/AuthGlobalHandler';

function App(): JSX.Element {
  return (
    <ConfigProvider>
      <Layout>
        <AuthGlobalHandler />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/users" element={<Users />} />
          <Route path="/tenants" element={<Tenants />} />
          <Route path="/workspaces" element={<Workspaces />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/support" element={<Support />} />
        </Route>
      </Routes>
    </Layout>
    </ConfigProvider>
  );
}

export default App;
